import useLocallyStoredState from "hooks/useLocallyStoredState";

export default () => useLocallyStoredState("ikeetmee_recent_groups", []);
